import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
const DIV = ({ children, ...props }) => <div {...props}>{children}</div>;

export default ({ children, col1Scroll = true, col2Scroll = true, col1Header = null }) => {
    const ContCol1 = col1Scroll ? Scrollbars : DIV;
    const ContCol2 = col2Scroll ? Scrollbars : DIV;
    return (
        <div style={{ display: 'flex', flexDirection: 'row', flexGrow: 1 }}>
            <div
                style={{
                    maxWidth: 280,
                    minWidth: 280,
                    height: '100%',
                    position: 'relative',
                    background: 'rgba(0,0,0,0.2)',
                }}
            >
                <div>{col1Header}</div>
                <ContCol1>
                    {children[0]}
                    <div style={{ height: 50 }} />
                </ContCol1>
                <h5
                    style={{
                        textAlign: 'center',
                        color: '#00505b',
                        position: 'absolute',
                        bottom: 0,
                        width: '100%',
                        zIndex: 100,
                        margin: 0,
                        lineHeight: '50px',
                        background: '#000',
                        textAlign: 'center',
                    }}
                >
                    SPORTSINNOVATION
                </h5>
            </div>

            <ContCol2
                style={{
                    minWidth: 260,
                    position: 'relative',
                    alignSelf: 'stretch',
                    flexDirection: 'column',
                    width: '100%',
                    height: '100%',
                }}
            >
                <div style={{ alignSelf: 'stretch' }}>{children[1]}</div>
            </ContCol2>
        </div>
    );
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/editor/components/controls/EditorStandartLayout.js
 **/